import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, TextField } from '@material-ui/core';
import {
  setUpdateUserName, setUpdateDate,
  setModifyPopFlg, updateUserInfo, setErrModifyPopMessage,
  searchUserList, setUserResultList,
} from '../../actions/UserManagedAction';
import {
  setSystemLodingFLg,
  setConfirmPopFlg,
  setPopMessage,
  setOnClickYesFunction,
  setOnClickNoFunction,
  setInfoMessage,
} from '../../actions/CommonAction';
import './UserManagedPopModifyComponent.css';
import validator from '../../../common/validator';
import { INFO, ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';

class UserManagedModifyComponent extends Component {
  constructor() {
    super();
    this.state = {
      editFlag: false,
      changedUserName: null,
      errUpdateUserName: null,
    };
  }

  /**
   * POPUP内初期化
   */
  initState = () => {
    const {
      setUpdateUserNameAct,
      setUpdateDateAct,
      setErrModifyPopMessageAct,
    } = this.props;
    setUpdateUserNameAct(null);
    setUpdateDateAct(null);
    setErrModifyPopMessageAct(null);
    this.setState({ changedUserName: null });
    this.setState({ errUpdateUserName: null });
  }

  /**
   * 更新後ユーザー名のバリデーションチェック
   */
  onBlurUpdateUserName = () => {
    const {
      changedUserName,
    } = this.state;
    // 更新後ユーザー名の入力チェック
    const msgs = [];
    this.checkUpdateUserName(changedUserName, msgs);
  }

  /**
   * 編集ボタン押下時の処理
   */
  onClickEditStartButton = () => {
    const {
      updateUserName,
    } = this.props;
    this.setState({ editFlag: true });
    this.setState({ changedUserName: updateUserName });
    this.setState({ errUpdateUserName: '' });
  }

  /**
   * キャンセルボタン押下時の処理
   */
  onClickEditEndButton = () => {
    this.setState({ editFlag: false });
    this.setState({ errUpdateUserName: '' });
  }

  /**
   * 更新ボタン押下時の処理
   */
  onClickUpdateButton = () => {
    const {
      setConfirmPopFlgAct,
      setOnClickYesFunctionAct,
      setOnClickNoFunctionAct,
      setPopMessageAct,
    } = this.props;
    const {
      changedUserName,
    } = this.state;
    const msgs = [];
    // 更新後ユーザー名のチェック
    if (this.checkUpdateUserName(changedUserName, msgs)) {
      return;
    }
    // 確認POPUP表示
    setPopMessageAct(INFO.I04005);
    setOnClickYesFunctionAct(this.onClickYesButton);
    setOnClickNoFunctionAct();
    setConfirmPopFlgAct(true);
  }

  /**
   * 確認POPUP「はい」選択時の処理
   */
  onClickYesButton = async () => {
    const {
      updateUserId,
      updateDate,
      searchUserId,
      searchUserName,
      searchRole,
      sortItem,
      sortOrder,
      nowPage,
      setSystemLodingFlgAct,
      setInfoMessageAct,
      setModifyPopFlgAct,
      updateUserInfoAct,
      searchUserListAct,
      setUserResultListAct,
    } = this.props;
    const {
      changedUserName,
    } = this.state;
    // ユーザー情報変更API呼出し
    setSystemLodingFlgAct(true);
    const ret = await updateUserInfoAct(
      updateUserId, changedUserName, updateDate,
    );
    setSystemLodingFlgAct(false);

    // 正常応答が返されたら変更完了メッセージを表示
    if (ret) {
      this.initState();
      setModifyPopFlgAct(false);
      setSystemLodingFlgAct(true);
      // stateに入っている条件で
      const response = await searchUserListAct(
        searchUserId,
        searchUserName,
        searchRole,
        sortItem,
        sortOrder,
        nowPage,
      );
      this.setState({ editFlag: false });
      setSystemLodingFlgAct(false);
      setInfoMessageAct(INFO.I04006);
      setUserResultListAct(response);
    }
  }

  /**
   * 閉じるボタン押下時の処理
   */
  onClickCancelButton = () => {
    const {
      setModifyPopFlgAct,
    } = this.props;
    // state初期化
    this.initState();
    setModifyPopFlgAct(false);
  }

  /**
   * 更新後ユーザー名チェック関数
   * @param {string} updateUserName 更新後ユーザー名
   * @param {[]} msgs メッセージ
   * @returns 入力判定結果(true：入力誤り、false：正しい入力)
   */
  checkUpdateUserName = (updateUserName, msgs) => {
    validator.checkMaxLength(updateUserName, 50, msgs);
    if (msgs.length !== 0) {
      // エラーメッセージとエラーフラグの設定
      this.setState({ errUpdateUserName: getMessage(ERROR.E08009, msgs.join(',')) });
      return true;
    }
    this.setState({ errUpdateUserName: '' });
    return false;
  }

  render() {
    const {
      modifyPopFlg,
      updateUserId,
      updateUserName,
      updateRoleList,
      updateDate,
      errModifyPopMessage,
    } = this.props;
    const {
      editFlag,
      errUpdateUserName,
    } = this.state;
    const {
      changedUserName,
    } = this.state;
    return (
      modifyPopFlg && (
        <div className="usermodify">
          <div className="contents">
            <div className="message">
              {editFlag
                ? <>ユーザー情報変更</>
                : <>ユーザー情報照会</>}
            </div>
            <div className="errmessage">{errModifyPopMessage}</div>
            <table className="usermodifyContent">
              <tbody>
                <tr className="row">
                  <td className="titleUser">ユーザーID</td>
                  <td className="itemUserId">{updateUserId}</td>
                </tr>
                <tr className="row">
                  <td className="titleName">ユーザー名</td>

                  {editFlag
                    ? (
                      <>
                        <td className="editItem">
                          <TextField
                            className="same_text"
                            InputProps={{ classes: { input: 'inputSizing' } }}
                            variant="outlined"
                            margin="normal"
                            value={changedUserName || ''}
                            onChange={(ev) => this.setState({ changedUserName: ev.target.value })}
                            onBlur={() => this.onBlurUpdateUserName()}
                            error={(errUpdateUserName !== '' && errUpdateUserName !== null) || false}
                          />
                          <div className="errorDiv">
                            <span className="error">{errUpdateUserName}</span>
                          </div>
                        </td>
                      </>
                    )
                    : (
                      <>
                        <td className="itemUserName">
                          <div className="textAreaWidth">
                            {updateUserName}
                          </div>
                          <div className="buttonAreaWidth">
                            <Button
                              variant="contained"
                              color="secondary"
                              className="editButton"
                              onClick={() => this.onClickEditStartButton(this)}
                            >
                              編集
                            </Button>
                          </div>
                        </td>
                      </>
                    )}

                </tr>
                <tr className="rowAuthority">
                  <td className="titleRole">権限</td>
                  <td className="itemList rollScrollbar">
                    {updateRoleList && updateRoleList.map((role) => (
                      <div key={role}>{role}</div>
                    ))}
                  </td>
                </tr>
              </tbody>
            </table>
            <input type="hidden" value={updateDate || ''} />
            <div className="button">
              {editFlag
                ? (
                  <>
                    <Button
                      variant="contained"
                      color="secondary"
                      className="cancel"
                      onClick={() => this.onClickEditEndButton(this)}
                    >
                      キャンセル
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => this.onClickUpdateButton(this)}
                      disabled={(errUpdateUserName !== '' && errUpdateUserName !== null) || false}
                    >
                      変更
                    </Button>
                  </>
                )
                : (
                  <Button
                    variant="contained"
                    color="secondary"
                    className="cancel"
                    onClick={() => this.onClickCancelButton(this)}
                  >
                    閉じる
                  </Button>
                )}
            </div>
          </div>
        </div>
      ));
  }
}

export default connect(
  (state) => ({
    updateUserId: state.usermanaged.updateUserId,
    updateUserName: state.usermanaged.updateUserName,
    updateRoleList: state.usermanaged.updateRoleList,
    updateDate: state.usermanaged.updateDate,
    confirmPopFlg: state.common.confirmPopFlg,
    modifyPopFlg: state.usermanaged.modifyPopFlg,
    errModifyPopMessage: state.usermanaged.errModifyPopMessage,
    searchUserId: state.usermanaged.searchUserId,
    searchUserName: state.usermanaged.searchUserName,
    searchRole: state.usermanaged.searchRole,
    sortItem: state.usermanaged.sortItem,
    sortOrder: state.usermanaged.sortOrder,
    nowPage: state.usermanaged.nowPage,
  }),
  (dispatch) => ({
    setUpdateUserNameAct: (str) => dispatch(setUpdateUserName(str)),
    setUpdateDateAct: (date) => dispatch(setUpdateDate(date)),
    setConfirmPopFlgAct: (bool) => dispatch(setConfirmPopFlg(bool)),
    setModifyPopFlgAct: (bool) => dispatch(setModifyPopFlg(bool)),
    setPopMessageAct: (str) => dispatch(setPopMessage(str)),
    setOnClickYesFunctionAct: (func) => dispatch(setOnClickYesFunction(func)),
    setOnClickNoFunctionAct: (func) => dispatch(setOnClickNoFunction(func)),
    setSystemLodingFlgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setErrModifyPopMessageAct: (str) => dispatch(setErrModifyPopMessage(str)),
    setInfoMessageAct: (str) => dispatch(setInfoMessage(str)),
    setUserResultListAct: (obj) => dispatch(setUserResultList(obj)),
    updateUserInfoAct: (
      userId, userName, updateDate,
    ) => dispatch(updateUserInfo(
      userId, userName, updateDate,
    )),
    searchUserListAct: (
      userId, userName, role, sortItem, sortOrder, pageNumber,
    ) => dispatch(searchUserList(
      userId, userName, role, sortItem, sortOrder, pageNumber,
    )),
  }),
)(UserManagedModifyComponent);
